import React from 'react'
import PropTypes from 'prop-types'
import LoginContainer from '../../Linkgua/containers/LoginContainer'

const widthClasses = {
  12: 'col-lg-12 col-sm-12 col-12',
  11: 'col-lg-11 col-sm-12 col-12',
  10: 'col-lg-10 col-sm-12 col-12',
  9: 'col-lg-9 col-sm-6 col-12',
  8: 'col-lg-8 col-sm-6 col-12',
  7: 'col-lg-7 col-sm-6 col-12',
  6: 'col-lg-6 col-sm-6 col-12',
  5: 'col-lg-5 col-sm-6 col-12',
  4: 'col-lg-4 col-sm-6 col-12',
  3: 'col-lg-3 col-sm-4 col-12',
  2: 'col-lg-2 col-sm-3 col-6',
  1: 'col-lg-1 col-sm-2 col-4'
}


const CardLayout = ({children, styleName, columns, childrenStyle}) => {
  return (
    <div className={widthClasses[columns] + ' card-layout ' + (styleName ? styleName : '')}>
      <div className={`card ${childrenStyle ? childrenStyle : ''}`}>
        {children}
      </div>
    </div>
  )
}

LoginContainer.propTypes = {
  children: PropTypes.node,
  styleName: PropTypes.string,
  columns: PropTypes.number,
  childrenStyle: PropTypes.string
}


export default CardLayout




// WEBPACK FOOTER //
// ./components/CardLayout/index.js